<template lang="pug">
  e-modal(
    @close="onClose"
    @confirm="saveOptimalSchema"
    title="Оптимальная схема размещения"
    saveBtnLabel="Разместить"
  )
    slot
      .form-group
        label.form-group__label.label Максимальное расстояние от МО до объекта инфраструктуры (в метрах)
        e-input.form__elem_input(
          name="max_distance_to_mo"
          inputType="input"
          :model="field"
        )
      .form-group
        label.form-group__label.label Максимальное расстояние до дороги (в метрах)
        e-select.form__elem_input(
          name="max_distance_to_road"
          inputType="input"
          :model="field"
          :options="roadOptions"
        )
</template>
<script>
import { tko } from '@/api/api-endpoints'
import { REGION_CONFIG } from '@/config/regions'
import L from 'leaflet'
import markerIcon from 'leaflet/dist/images/marker-icon.png'
import iconShadow from 'leaflet/dist/images/marker-shadow.png'
import year from '@/utils/year'

export default {
  name: 'OptimalSchema',
  props: {
    map: {
      type: Object,
      required: true,
    },
    year: {
      type: Number,
      default: year.getCurrentYear(),
    },
  },
  data() {
    return {
      mapCenter: REGION_CONFIG.map,
      field: {
        max_distance_to_mo: '500',
        max_distance_to_road: '50',
      },
      objects: [],
      objectsLayer: null,
      roadOptions: [
        { id: 50, name: 50 },
        { id: 100, name: 100 },
        { id: 200, name: 200 },
        { id: 300, name: 300 },
        { id: 400, name: 400 },
        { id: 500, name: 500 },
      ],
    }
  },
  computed: {
    yearOptions() {
      const date = new Date()
      const years = []
      const yearStart = date.getFullYear()
      const yearFinish = yearStart + 10
      for (let i = yearStart; i < yearFinish; i++) {
        years.push({ id: i, name: i })
      }
      return years
    },
  },
  methods: {
    onClose() {
      this.$emit('close')
    },
    setCoords(coords) {
      this.$emit('saveOptimalSchema', coords)
    },
    async saveOptimalSchema() {
      const { max_distance_to_mo, max_distance_to_road } = this.field
      if (!max_distance_to_road || !max_distance_to_mo) {
        this.$e.errorBox('Заполните обязательные поля!')
        return false
      }
      const query = {
        max_distance_to_road,
        max_distance_to_mo,
        year: this.year,
      }
      this.$bar.start()

      this.objects = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: tko.optimalObjectCoords({
            query,
          }),
        })
      ).data
      this.drawObjects()
      this.$notify.success({
        title: `Объекты размещены`,
      })
      this.$bar.finish()
    },
    removeIcons() {
      this.map.eachLayer((l) => {
        if (
          l?.options?.pane === 'markerPane' ||
          l?.options?.pane === 'overlayPane'
        ) {
          l.remove()
        }
      })
    },
    addContentToObjectPopup(data) {
      return `<div class='map-popup'>
                <div class="map-popup__body">
                     <div class='map-popup__prop semibold'>Назначение объекта:</div>
                     <div class='map-popup__value'>${data.action}</div>
                     <div class='map-popup__prop semibold'>Расстояние до дороги:</div>
                     <div class='map-popup__value'>${data.distance_to_road}</div>
                      <div class='map-popup__prop semibold'>Мощность:</div>
                     <div class='map-popup__value'>${data.power}</div>
                </div>
            </div>
        `
    },
    drawObjects() {
      this.removeIcons()
      this.objectsLayer = L.featureGroup()
      this.objectsLayer.addTo(this.map)
      this.objects.forEach((object) => {
        const icon = L.icon({
          iconUrl: markerIcon,
          shadowUrl: iconShadow,
          iconSize: [25, 41],
          iconAnchor: [13, 20],
        })
        const circleLayer = L.circle([object.latitude, object.longitude], {
          radius: 2000,
        })
        const iconLayer = L.marker([object.latitude, object.longitude], {
          icon: icon,
        })
        const popup = L.popup()
        popup.setContent(this.addContentToObjectPopup(object))
        iconLayer.bindPopup(popup)
        iconLayer.addTo(this.objectsLayer)
        circleLayer.addTo(this.objectsLayer)
      })
      this.$emit('close')
    },
  },
}
</script>
